/** @jsxImportSource @emotion/react */

import { useState } from 'react';
import { connect } from 'unistore/react';
import { css } from '@emotion/react';

import AlertsRow from './alerts-row';
import { bubbleStyle, headingStyle } from '../common';

import ErrorBoundary from '../../../components/ErrorBoundary';
import { Button } from '@components';
import IfElse from '../../../components/IfElse';

import {
	actionsCombiner,
	sidebarActions,
	userAlertActions,
} from '@utils/store/actions';

const UserAlerts = ({ userAlerts, flush, userAlertsCount, innerRef }) => {
	const [show, setShow] = useState(true);

	return (
		<ErrorBoundary>
			<div>
				<div
					className="border-b border-gray-400 border-t border-separatorColor flex items-center justify-between p-4 cursor-pointer"
					css={headingStyle}
					onClick={() => setShow(!show)}
				>
					<div className="font-bold text-primary uppercase">
						Alerts:
						{userAlertsCount > 0 && (
							<div css={bubbleStyle}>{userAlertsCount}</div>
						)}
					</div>
					{userAlerts.length > 0 && (
						<div>
							<Button
								onClick={flush}
								variant="minimal"
								size="tiny"
								className="mr-4"
								css={css`
									margin: -6px 10px -6px 0px;
								`}
							>
								Clear Alerts
							</Button>
							<Button
								variant="minimal"
								className="p-2 text-base"
								size="tiny"
								css={css`
									margin: -6px 0;
									height: 24px;
									line-height: 0.8;
									width: 30px;
								`}
							>
								{show ? (
									'—'
								) : (
									<span className="text-lg">+</span>
								)}
							</Button>
						</div>
					)}
				</div>
				{(show || userAlerts.length === 0) && (
					<ul
						className="mt-0 p-0 bb-notifList"
						css={css`
							flex: 1;
						`}
						ref={innerRef}
					>
						<IfElse
							condition={userAlerts.length > 0}
							then={userAlerts.map((notif, index) => (
								<ErrorBoundary key={notif.log_id}>
									<AlertsRow index={index} {...notif} />
								</ErrorBoundary>
							))}
							else={
								<li className="py-12 flex items-center flex-col">
									<img
										src="https://bitbns.com/assets/img/empty-notifications.svg"
										alt="Empty"
										css={css`
											height: 80px;
											max-width: 100%;
										`}
									/>
									<div className="font-bold mt-4 text-lightGray">
										None... Ø... Zilch!
									</div>
									<div className="mt-2 text-lavender text-xs">
										Just like Fiat&apos;s backing!
									</div>
								</li>
							}
						/>
					</ul>
				)}
			</div>
		</ErrorBoundary>
	);
};

export default connect(
	'userAlertsMuted, userAlerts, userAlertsCount',
	actionsCombiner(userAlertActions, sidebarActions)
)(UserAlerts);
